import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { LoadingSpinner } from "./LoadingSpinner";
import { Button } from "./ui/button";
import {
    Card,
    CardContent,
} from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Mail } from "lucide-react";

const emailSchema = z.object({
    email: z.email({ message: "Please enter a valid email address." }),
});

export type EmailFormData = z.infer<typeof emailSchema>;

interface EmailCardProps {
    onEmailSubmit: (data: EmailFormData) => void;
    isLoading: boolean;
}

export const EmailCard: React.FC<EmailCardProps> = ({
    onEmailSubmit,
    isLoading,
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<EmailFormData>({
        resolver: zodResolver(emailSchema),
        mode: "onChange",
    });

    return (
        <Card className="w-full max-w-md mx-auto shadow-xl border-slate-100">
            <CardContent>
                <form onSubmit={handleSubmit(onEmailSubmit)} className="space-y-6">
                    <div className="space-y-2">
                        <Label htmlFor="email">Email</Label>
                        <div className="relative">
                            <Mail className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
                            <Input
                                id="email"
                                type="email"
                                placeholder="name@example.com"
                                disabled={isLoading}
                                autoComplete="email"
                                {...register("email")}
                                className={`pl-9 ${errors.email ? "border-destructive focus-visible:ring-destructive" : ""
                                    }`}
                            />
                        </div>
                        {errors.email && (
                            <p className="text-sm font-medium text-red-400">
                                {errors.email.message}
                            </p>
                        )}
                    </div>
                    <Button
                        type="submit"
                        className="w-full"
                        disabled={!isValid || isLoading}
                    >
                        {isLoading ? (
                            <LoadingSpinner size="sm" text="Sending..." />
                        ) : (
                            "Continue"
                        )}
                    </Button>
                </form>
            </CardContent>
        </Card>
    );
};
